import React, { ReactNode } from 'react'

import { VisibilitySensor } from '@icontainers/design-system/dist/atoms/VisibilitySensor'

import { getRevealerStyles, Styles } from './utils'

export type WrapperProps = Styles & {
    children: ReactNode
}

export const Wrapper = (props: WrapperProps): JSX.Element => {
    const { children, type, offset, transition, delay } = props

    return (
        <VisibilitySensor once partialVisibility>
            {({ isVisible }: { isVisible: boolean }) => (
                <div style={getRevealerStyles({ type, offset, transition, delay }, isVisible)}>{children}</div>
            )}
        </VisibilitySensor>
    )
}
